// import { useTranslation } from "react-i18next";
import { LockClosedIcon } from "@heroicons/react/24/outline";
import "../style/style-cargando.css";

// export default function SinAccesoCard() {

// const { t } = useTranslation();
const SinAccesoCard = () => {
    const render = () => {
        try {
            return (
                <div className="flex items-center justify-center min-h-[60vh] px-4 py-12">
                    <div className="max-w-lg w-full">
                        <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden transform transition-all hover:scale-[1.01]">
                            {/* Header with gradient */}
                            <div className="bg-gradient-to-br from-red-500 via-red-600 to-red-700 px-8 py-12 relative overflow-hidden">
                                {/* Decorative circles */}
                                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -mr-16 -mt-16"></div>
                                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white/10 rounded-full -ml-12 -mb-12"></div>

                                <div className="flex flex-col items-center justify-center relative z-10">
                                    <div className="bg-white/20 backdrop-blur-md rounded-full p-5 mb-6 ring-4 ring-white/30">
                                        <LockClosedIcon className="h-20 w-20 text-white" strokeWidth={1.5} />
                                    </div>
                                    <h2 className="text-3xl font-bold text-white text-center mb-2">
                                        Access Denied
                                    </h2>
                                    <div className="h-1 w-24 bg-white/40 rounded-full"></div>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="px-8 py-10 bg-gradient-to-b from-gray-50 to-white">
                                <div className="text-center">
                                    <p className="text-gray-700 text-lg font-medium mb-3 leading-relaxed">
                                        You do not have permission to access this module.
                                    </p>
                                    <p className="text-gray-500 text-base leading-relaxed">
                                        Called the administrator to request access.
                                    </p>
                                </div>

                                {/* Decorative divider */}
                                <div className="flex items-center justify-center mt-8 mb-6">
                                    <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                                    <div className="mx-4">
                                        <LockClosedIcon className="h-5 w-5 text-gray-400" />
                                    </div>
                                    <div className="flex-1 h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent"></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            );
        } catch (err) {
            console.log('render err');
            console.log(err);
            return (
                <div>
                    <label>No Access</label>
                </div>
            );
        }
    }

    return render();
}
export default SinAccesoCard;